<mat-selection-list [formControl]="kontroller()" [multiple]="tillatVelgFlere()" [hideSingleSelectionIndicator]="false" [attr.aria-labelledby]="ariaLabelledBy()" [attr.aria-label]="ariaLabel()" data-testid="soekeresultatListing">
  @for (undersoekelse of tilgjengeligeUndersoekelser(); track undersoekelse.id) {
    <mat-list-option [value]="undersoekelse" togglePosition="before">
      <span matListItemTitle> {{ undersoekelse.tittel }} </span>
      <span matListItemLine>
        @if (undersoekelse.erAapenForRespons) {
          {{ 'Svarfrist {dato}'|translate:{dato: undersoekelse.responsperiode!.slutt|zoneddatetimeSomPlaindate|plaindate} }}
        } @else if (undersoekelse.erAvsluttet) {
          {{ 'Gjennomført {dato}'|translate:{dato: (undersoekelse.responsperiode!.start|zoneddatetimeSomPlaindate|plaindate:{year: 'numeric', month: 'short'})} }}
        } @else {
          {{ 'Undersøkelsen har ikke blitt aktivert'|translate }}
        }
        @if (undersoekelse.behandlinger.length > 0) {
          <div class="behandlinger">
            <span>{{ 'Spørreundersøkelsen behandles allerede i '|translate }}</span>
            <ul>
              @for (sak of undersoekelse.behandlinger; track sak.id) {
                <li matTooltip="{{'Sak {nummer} {tittel}' |translate: {nummer: sak.nummer, tittel: sak.tittel} }}">
                  {{ sak.moete.tittel }} {{ sak.moete.nummer }}, {{ sak.moete.dato.start|zoneddatetimeSomPlaindate|plaindate }}
                </li>
              }
            </ul>
          </div>
        }

        <!--blir ikke visuelt bra med deltaker-grafikken.. derfor kommentert ut
        <span class="metainformasjon">
          <c3-todelt-pai [totalt]="undersoekelse.antallRespondenter"
                         [andel]="undersoekelse.antallRespondenterSvart"
                         visningstype="donut"
                         matTooltip="{{ '{antallSvar} av {antallRespondenter} har svart' | translate:{antallSvar:undersoekelse.antallRespondenterSvart, antallRespondenter:undersoekelse.antallRespondenter} }}"/>
          {{ 'Gjennomført {dato}'|translate:{dato: (undersoekelse.responsperiode!.start|zoneddatetimeSomPlaindate|plaindate:{year: 'numeric', month: 'short'})} }}
        </span>-->
      </span>
    </mat-list-option>
  }
</mat-selection-list>
